var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('page-header'),_c('page-nav',{attrs:{"content-data":_vm.ContentData}}),_c('page-body',{attrs:{"content-data":_vm.ContentData}}),_c('page-footer'),_c('icon-spritesheet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }